module.exports = __webpack_public_path__ + "img/hostingsimplubifa@3x.6f3feb14.png";